/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AdminTable from '../../../components/AdminTable';
import DashboardHeaderWithFilters from '../../../components/DashboardHeaderWithFilters';
import EmptyRecord from '../../../components/EmptyRecord';
import useFilterMethods from '../../../customHooks/useFilterMethods';
import useGetQueryParams from '../../../customHooks/useGetQueryParams';
import useTableColumn from '../../../customHooks/useTableColumn';
import useToast from '../../../customHooks/useToast';
import { GET_PROPERTY_AGENTS } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import EmptyMerchantSettlement from '../../../svgs/EmptyMerchantSettlement';
import ListIcon from '../../../svgs/ListIcon';
import generateCSV from '../../../utils/generateCSV';
import generatePDF from '../../../utils/generatePdf';
import { cleanUpRealtorCode } from '../../../utils/helpers';
import { AdminRouteName } from '../../CONSTANTS';
import ActivateRealtor from '../ActivateAgent';
import DeactivateRealtor from '../DeactivateAgent';
import GenerateRealtorTrackingCodeModal from '../GenerateRealtorTrackingCode';
import Styles from './RealtorTrackingRecordSection.module.scss';

const limit = 14;
interface IRealtorTrackingRecordSection{
  isShowGenerateCodeModal:boolean;
  setIsShowGenerateCodeModal:any;
}
const RealtorTrackingRecordSection = ({ isShowGenerateCodeModal, setIsShowGenerateCodeModal }:IRealtorTrackingRecordSection) => {
  const Toast = useToast();
  const [getPropertyAgents, getPropertyAgentsLoading, propertyAgents] = useCustomQuery({
    query: GET_PROPERTY_AGENTS,
    onError: () => {},
    onData: () => {},
  });
  const { getQuery, getFilterQueries } = useGetQueryParams();
  const search = getQuery('search') || '';
  const page = Number(getQuery('page'));
  const { push } = useHistory();

  const [selectedMember, setSelectedMember] = useState(null);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const allColumns = [
    ['image', 'email', 'hasBottomValue', 'name'],
    'code',
    'totalRealtors',
    'status',
    'date',
  ];
  const columnLabelFormat = {
    name: 'Name of Realtor',
    code: 'Tracking Code',
    totalRealtors: 'No. of Referrals',
    status: 'Status',
    date: 'Date Created',
  };
  const { getColumns } = useTableColumn(allColumns, 'reward');

  const [rewardsRec, setRewardsRec] = useState(null);
  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };
  if (!page) {
    push(`/${AdminRouteName?.rewardrealtorsTrackingCode}?page=1&search=${search}`);
  }

  const onSearchChange = (e) => {
    const result = getFilterQueries();
    push(`${AdminRouteName?.rewardrealtorsTrackingCode}?page=1&search=${encodeURIComponent(e.target.value)}&fromDateTable=${result?.fromDateTable}&toDateTable=${result?.toDateTable}`);
  };

  useEffect(() => {
    if (page) {
      const result = getFilterQueries();
      getPropertyAgents({
        variables: {
          offset: (page - 1) * limit,
          limit,
          search,
          from: result?.fromDateTable,
          to: result?.toDateTable,
        },
      });
    }
  }, [page, search]);

  const getRewardFunc = (result) => {
    getPropertyAgents({
      variables: {
        offset: 0,
        limit,
        search,
        from: result?.fromDateTable,
        to: result?.toDateTable,
      },
    });
  };

  const onFilterSubmit = (result) => {
    getRewardFunc(result);
  };

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: ['tableDateRange'],
    defaultUrl: `/${AdminRouteName?.rewardrealtorsTrackingCode}?page=1`,
    cb: onFilterSubmit,
    Toast,
  });

  useEffect(() => {
    if (propertyAgents?.getPropertyAgents?.data) {
      setRewardsRec(propertyAgents?.getPropertyAgents
        ?.data);
    }
  }, [propertyAgents]);

  const [getExportRecord] = useCustomQuery({
    query: GET_PROPERTY_AGENTS,
    onError: () => {},
    onData: () => {},
  });

  const handleExport = async (type: string) => {
    try {
      const result = getFilterQueries();
      const output = await getExportRecord({
        variables: {
          offset: 0,
          limit: 2000,
          search,
          from: result?.fromDateTable,
          to: result?.toDateTable,
        },
      });

      if (output?.data?.getPropertyAgents?.data) {
        const rec = cleanUpRealtorCode(output?.data?.getPropertyAgents?.data?.propertyAgents);
        const func = type === 'pdf' ? generatePDF : generateCSV;
        const selectedHeaders = [
          'S/N',
          // change image__email__hasBottomValue__name concated columns to a single column of name
          ...(getColumns?.()?.map((column) => (column === 'image__email__hasBottomValue__name' ? ['name', 'email'] : column)) || []),
        ];

        func({
          payload: rec,
          title: 'Realtor’s Tracking Code',
          selectedHeaders,
          formatHeaders: columnLabelFormat,
          cb: () => Toast.success('Exported successfully'),
        });
      }
    } catch (error) {
      Toast.error('Error while exporting');
    }
  };

  const handleRoute = (data:any) => {
    push(`/rewards/realtor-details/${data?.id
    }`);
  };

  const handleSelectDropdown = (data, details) => {
    if (data === 'Activate') {
      setSelectedMember(details);
      setShowActivateModal(true);
      return;
    }
    if (data === 'Deactivate') {
      setSelectedMember(details);
      setShowDeactivateModal(true);
      return;
    }
    push(`/rewards/realtor-details/${details?.id}`);
  };

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__header}>
        <DashboardHeaderWithFilters
          title="Realtor’s Code"
          filterObj={filterObj}
          dateType="tableDateRange"
          showSearch
          search={search}
          onSearchChange={onSearchChange}
          searchPlaceholder="Customer name /  Email address"
          exportObj={{
            handleExport,
          }}
        />
      </div>

      <div className="transaction-table-details-cover">
        {rewardsRec?.count ? (
          <AdminTable
            refreshing={getPropertyAgentsLoading}
            page={page}
            setPage={setPage}
            pageSize={limit}
            minHeight="calc(100vh - 280px)"
            count={rewardsRec?.count}
            contents={cleanUpRealtorCode(rewardsRec?.propertyAgents)}
            reference="id"
            hideDominantImage
            hasNameAndImage
            clickable
            handleClick={handleRoute}
            allowKeyArr={getColumns(true)}
            mobileAllowKeyArr={
              [
                'status',
                ['name', 'email'],
                ['code', 'date'],
              ]
            }
            handleDropdown={handleSelectDropdown}
            formatLabels={columnLabelFormat}
            dropdownType="realtor"
            dropDownIcon={<div className={Styles.wrapper__icon}><ListIcon /></div>}
          />
        ) : (
          <EmptyRecord
            height="calc(100vh - 240px)"
            title={getPropertyAgentsLoading ? 'Fetching Realtor’s Code...' : 'No Realtor’s Code yet'}
            main="All Realtor’s Code on Payfi will appear here"
            // footer="Receive Payments"
            loading={getPropertyAgentsLoading}
            Icon={EmptyMerchantSettlement}
          />
        )}

      </div>
      {
        isShowGenerateCodeModal && <GenerateRealtorTrackingCodeModal refetch={getRewardFunc} closeModal={() => setIsShowGenerateCodeModal(false)} />
      }

      {
        showActivateModal && selectedMember && <ActivateRealtor payload={selectedMember} onClose={() => setShowActivateModal(false)} refetch={getRewardFunc} />
      }
      {
        showDeactivateModal && selectedMember && <DeactivateRealtor payload={selectedMember} onClose={() => setShowDeactivateModal(false)} refetch={getRewardFunc} />
      }

    </div>
  );
};

export default RealtorTrackingRecordSection;
